import { Navigation, Pagination } from 'swiper/modules';

/**
 * Carousel composable.
 *
 * @param   {boolean} hasPagination Whether or not the carousel should implement pagination.
 * @returns {object}                Exposed carousel properties and methods.
 */
export function useCarousel(hasPagination = true) {
    const standardCarouselConfig = {
        loop: true,
        modules: [Navigation, Pagination],
        navigation: {
            enabled: true,
            nextEl: '.carousel-nav-next',
            prevEl: '.carousel-nav-prev',
        },
    };

    if (hasPagination) {
        standardCarouselConfig.pagination = {
            enabled: true,
            clickable: true,
            modifierClass: 'carousel-pagination-',
            bulletClass: 'carousel-pagination-bullet',
            bulletActiveClass: 'carousel-pagination-bullet-active',
        };
    }

    return { standardCarouselConfig };
}
